import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ArrowRightSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowRightSmallIconPath";
import { ComponentNotificationBodyAssignedProduct } from "../types/task-notification.types";
import styles from "../task-notification.module.css";
import {
  getBodyAssignerString,
  getItemNameIdString,
} from "../utils/task-notification-body";

interface TaskNotificationBodyAssignedProductProps extends ComponentNotificationBodyAssignedProduct {
  read: boolean;
}
const TaskNotificationBodyAssignedProduct = ({
  props: { itemInfo, oldAssignedTo, newAssignedTo },
}: TaskNotificationBodyAssignedProductProps) => {
  const oldAssignedToString = getBodyAssignerString(oldAssignedTo);
  const newAssignedToString = getBodyAssignerString(newAssignedTo);
  const itemNameIdString = getItemNameIdString(itemInfo);
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      {itemInfo?.imageUrl && (
        <div className={styles["task-notification-item-item-image"] ?? ""}>
          <img
            src={itemInfo.imageUrl}
            alt={itemInfo.name}
            width="44"
            height="44"
          />
        </div>
      )}
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {!!oldAssignedToString && !!newAssignedToString && (
          <div>
            <span
              className={
                styles["task-notification-item-body-old-assigned"] ?? ""
              }
            >
              {oldAssignedToString}
            </span>
            <FixaSSRIcon paths={ArrowRightSmallIconPath} />
            <span>{newAssignedToString}</span>
          </div>
        )}
        {!!itemNameIdString && <div>{itemNameIdString}</div>}
      </div>
    </div>
  );
};

export default TaskNotificationBodyAssignedProduct;
